// Small brand-specific icons not in lucide-react

export function TiktokIcon({ className = "w-4 h-4", strokeWidth: _sw = 1.5, ...rest }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      <path d="M16.5 3h2.7c.1 1.3.6 2.5 1.5 3.4.9.9 2.1 1.4 3.4 1.5v2.7c-1.8-.1-3.5-.7-5-1.7v7.3a5.9 5.9 0 1 1-5.9-5.9c.3 0 .6 0 .9.1v2.8c-.3-.1-.6-.1-.9-.1a3.1 3.1 0 1 0 3.1 3.1V3z" />
    </svg>
  );
}
